// extracted by mini-css-extract-plugin
export default {"Button":"styles_Button__R8htc","disabled":"styles_disabled__ni845"};